import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chat",
  "use": "icon-chat-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" fill=\"none\" id=\"icon-chat\">\n  <path d=\"M5.79744 13.625H16.25V5.5H3.75V15.3312L5.79744 13.625ZM3.11507 17.4874C2.87082 17.691 2.5 17.5173 2.5 17.1994V5.5C2.5 4.80964 3.05964 4.25 3.75 4.25H16.25C16.9404 4.25 17.5 4.80964 17.5 5.5V13.625C17.5 14.3154 16.9404 14.875 16.25 14.875H6.25L3.11507 17.4874Z\" fill=\"black\" fill-opacity=\"0.9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol